<div class="form-metrics-widget" [class.form-metrics-widget--clickable]="categoryClickEnabled" *ngIf="item">
  <h6 class="widget-title">{{ item.label }}</h6>
  <p class="widget-meta text-muted mb-1">{{ item.totalAnswers }} resposta(s)</p>

  <ng-container *ngIf="item.totalAnswers > 0 && chartOptions; else empty">
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [colors]="chartOptions.colors"
      [plotOptions]="chartOptions.plotOptions"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
      [grid]="chartOptions.grid"
      [legend]="chartOptions.legend"
      [fill]="chartOptions.fill"
      [stroke]="chartOptions.stroke || {}"
      [dataLabels]="chartOptions.dataLabels"
      [tooltip]="chartOptions.tooltip"
      [noData]="chartOptions.noData">
    </apx-chart>
    <!-- Standby: USE_CUSTOM_CHART_LEGEND — religar via flag no util -->
    <app-form-metrics-chart-legend
      *ngIf="legendItems?.length"
      [items]="legendItems"></app-form-metrics-chart-legend>
  </ng-container>

  <ng-template #empty>
    <p class="text-muted text-center py-3 mb-0">Sem respostas no período selecionado.</p>
  </ng-template>
</div>
